import { Card, Col, Row } from "react-bootstrap"

function LinkExpirado({error}){

    return (
        <Row>
            <Col xs="12" md={{span: 4, offset: 4}}>
                <Card>
                    <Card.Body>
                        <Row>
                            <Col>
                                <p dangerouslySetInnerHTML={{__html: error?.message}}></p>
                                
                                <p className="mt-3 mb-1">Tiempos para cancelación o reagendamiento de cita</p>
                                <ul>
                                    <li>Medicina general y pediatría (2 horas antes).</li>
                                    <li>Otras especialidades (24 horas antes).</li>
                                </ul>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    )
}

export default LinkExpirado